import $ from "jquery";
$(".menu-mobile-toggle").on("click", function() {
  const $mmenu = $(".ybc-menu-toggle");
  const wrapper = $mmenu.next(".mm_menus_ul");
  if ($mmenu.hasClass("closed")) {
    $(this).addClass("menu-opened");
    $("body").addClass("noscroll menu-mobile-open");
    $mmenu.removeClass("closed");
    $mmenu.addClass("opened");
    wrapper.stop(true, true).addClass("active");
    $(".mobile-buttons").removeClass("hidden");
  } else {
    $("body").removeClass("noscroll menu-mobile-open");
    $(this).removeClass("menu-opened");
    $mmenu.addClass("closed");
    wrapper.stop(true, true).removeClass("active");
    $(".mobile-buttons").addClass("hidden");
    $(".mm_tabs_li.mm_tabs_has_content").removeClass("mobile-open-child");
    $(".mm_menus_ul.active .sub-menu-vertical").removeClass("mm_tab_child-open");
  }
});
const hasSubItemSelector = " .menu-mobile-open .mm_tabs_li.mm_tabs_has_content .mm_tab_li_content .ets_mm_url";
$(document).on("click", hasSubItemSelector, function(event) {
  event.preventDefault();
  var menuItem = $(this);
  if (menuItem.closest(".mm_tabs_li.mm_tabs_has_content").hasClass("mobile-open-child")) {
    window.location.href = menuItem.attr("href");
    return;
  }
  $(".mm_menus_ul.active .sub-menu-vertical").toggleClass("mm_tab_child-open");
  menuItem.closest(".mm_tabs_li.mm_tabs_has_content").toggleClass("mobile-open-child");
  $(".mobile-buttons").toggleClass("d-none");
});
const goBackSelectorMenu = ".menu-mobile-open .mm_tabs_li.mm_tabs_has_content .mm_tab_li_content";
$(document).on("click", goBackSelectorMenu, function(event) {
  var menuItem = $(this);
  if (!$(event.target).closest(".ets_mm_url").length) {
    $(".mm_menus_ul.active .sub-menu-vertical").removeClass("mm_tab_child-open");
    menuItem.closest(".mm_tabs_li.mm_tabs_has_content").removeClass("mobile-open-child");
    $(".mobile-buttons").removeClass("d-none");
  }
});
const subItemLevel3Togglable = ".menu-mobile-open .mm_columns_li .ets_mm_block .h4:not(:has(+ .ets_mm_block_content > .mm_img_content))";
$(document).on("click", subItemLevel3Togglable, function() {
  $(this).next(".ets_mm_block_content").slideToggle();
});
